import { useMutation } from '@tanstack/react-query'
import { createApiCall } from 'services'

type BulkActivateResult = {
  id: string
  status: 'activated' | 'skipped' | 'failed'
  code?: string
  message?: string
}

type BulkActivateResponse = {
  results: BulkActivateResult[]
  summary: {
    requested: number
    activated: number
    skipped: number
    failed: number
  }
}

type UseCertificateBulkActivateOptions = {
  onSuccess?: (data?: BulkActivateResponse) => void
  onError?: (error?: any) => void
}

export const useCertificateBulkActivate = (
  options?: UseCertificateBulkActivateOptions
) => {
  const mutation = useMutation({
    mutationFn: async (ids: string[]) => {
      const response = await createApiCall({
        method: 'POST',
        url: `/certificates/admin/bulk-activate`,
        data: { ids },
      })
      return response.data as BulkActivateResponse
    },
    onSuccess: (data) => {
      options?.onSuccess?.(data)
    },
    onError: (error: any) => {
      options?.onError?.(error)
    },
  })

  const bulkActivate = (payload: { ids: string[] }) => {
    mutation.mutate(payload.ids)
  }

  return {
    bulkActivate,
    isLoading: mutation.isPending,
    isError: mutation.isError,
  }
}
